import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useGlobalState } from "./services/context/AuthContext";
import { extractAllowedCodes } from "./constants/helper";
import { conditionalCodes, impliedPermissions } from "./constants/menuItem";

interface PermissionGuardProps {
  children: ReactNode;
  code: string;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  children,
  code,
}) => {
  const { permission } = useGlobalState(); // permission: Permission[]
  const allowedCodes = extractAllowedCodes(
    permission || [],
    impliedPermissions,conditionalCodes
  );
  const hasPermission = allowedCodes?.includes(code);

  if (!hasPermission) {
    return <Navigate to="/pagenotfound" replace />;
  }

  return <>{children}</>;
};

export default PermissionGuard;
